var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.3724 0.368124C9.88245 -0.121876 9.09245 -0.121876 8.60245 0.368124L0.292451 8.67813C-0.0975493 9.06813 -0.0975493 9.69813 0.292451 10.0881L8.60245 18.3981C9.09245 18.8881 9.88245 18.8881 10.3725 18.3981C10.8625 17.9081 10.8625 17.1181 10.3725 16.6281L3.13245 9.37813L10.3824 2.12812C10.8624 1.64812 10.8624 0.848124 10.3724 0.368124Z","fill":"#9E9E9E"}));
}

Arrow.defaultProps = {"width":"11","height":"19","viewBox":"0 0 11 19","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
